import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Modal as M} from 'react-bootstrap'

export const Galeria = (props) => {
	const {empresa, getGaleriaEmpresa, GaleriaEmpresa} = props;

	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [ModalBorrarFoto, setModalBorrarFoto] = useState(false);

	const [ModalEnviarFoto, setModalEnviarFoto] = useState(false);

	const [FaseSeleccionFoto, setFaseSeleccionFoto] = useState(0);

	const [FotoEnviar, setFotoEnviar] = useState();

	const [IdBorrarFoto, setIdBorrarFoto] = useState();

	const borrarFoto = () => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'galeriaEmpresa/' + IdBorrarFoto + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				console.log(response);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const enviarFoto = () => {
		const formData = new FormData();
		const imagenOriginal = new Image(); // Crear un objeto imagen
		imagenOriginal.src = URL.createObjectURL(FotoEnviar.fotoPerfil); // Cargar la imagen en el objeto

		// Esperar a que la imagen se cargue
		imagenOriginal.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Definir la resolución deseada
			const ancho = 370 * 1.5; // ancho deseado
			const alto = 220 * 1.5; // alto deseado

			// Redimensionar la imagen en el canvas
			canvas.width = ancho;
			canvas.height = alto;
			ctx.drawImage(imagenOriginal, 0, 0, ancho, alto);

			// Convertir el canvas a una imagen PNG y agregarla al formulario
			canvas.toBlob(
				(blob) => {
					formData.append(
						'imagen',
						blob,
						'Foto-' + Usuario.prestadorServicios.nombreEmpresa + '.png'
					); // Cambiar la extensión a ".png"
					formData.append('nombre', 'Foto-' + Usuario.prestadorServicios.nombreEmpresa);
					formData.append('usuario_id', Usuario.prestadorServicios.usuario.id);

					// Enviar la imagen al servidor
					axios
						.post(window.ipdirection + 'galeriaEmpresa/', formData, {
							headers: {
								Authorization: 'Bearer ' + Usuario.access,
							},
						})
						.then((response) => {
							setModalEnviarFoto(false);
							getGaleriaEmpresa();
						})
						.catch((error) => {
							setFaseSeleccionFoto(1);
						});
				},
				'image/png',
				0.8
			); // Cambiar el tipo a "image/png"
		};
	};

	const fotoNoEnviada = () => {
		setModalEnviarFoto(false);
		setFaseSeleccionFoto(0);
	};

	return (
		<>
			<M
				centered={true}
				show={ModalEnviarFoto}
			>
				<M.Header>
					{FaseSeleccionFoto === 0 ? (
						<div className='titulo-modal'>Elige la mejor imagen</div>
					) : (
						<div className='titulo-modal'>Oops! Algo salió mal.</div>
					)}
				</M.Header>
				<M.Body>
					{FaseSeleccionFoto === 0 ? (
						<>
							<div className='descripcion-servicio descripcion-modal'>
								Selecciona la foto más atractiva y profesional que represente tu
								marca y servicios
							</div>
							<br />
							<div>
								<input
									type='file'
									className='form-control text-dark'
									accept='image/*'
									onChange={(e) =>
										setFotoEnviar({
											...FotoEnviar,
											fotoPerfil: e.target.files[0],
										})
									}
								/>
							</div>
						</>
					) : (
						<div className='descripcion-servicio descripcion-modal'>
							Lo sentimos, ha habido un problema al subir tu foto. Por favor, intenta
							de nuevo más tarde o revisa que el archivo sea compatible con nuestro
							formato. Si continúas teniendo problemas, no dudes en contactar a
							nuestro servicio de atención al cliente. Estamos aquí para ayudarte a
							solucionar cualquier problema y asegurarnos de que puedas mostrar tu
							mejor imagen al mundo.
						</div>
					)}
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn btn-outline-danger'
							onClick={() => {
								setModalEnviarFoto(false);
							}}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn login-boton'
							onClick={() => {
								FaseSeleccionFoto === 0 ? enviarFoto() : fotoNoEnviada();
							}}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
			<M
				centered={true}
				show={ModalBorrarFoto}
			>
				<M.Header>
					<div className='titulo-modal'>Galería de imágenes</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						¿Seguro que quieres borrar esta imagen de tu empresa? Esta acción es
						irreversible.
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn outline-boton'
							onClick={() => setModalBorrarFoto(false)}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn btn-outline-danger'
							onClick={() => {
								borrarFoto();
								getGaleriaEmpresa();
								setModalBorrarFoto(false);
							}}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
			<div className='body-galeria'>
				<div className='descripcion-servicio descripcion-modal descricip-subir-fotos'>
					¡Bienvenido! Aquí puedes subir hasta 8 fotos de tu empresa para que los clientes
					las vean. Usa una resolución de (555 x 330px) para que se vean mejor. ¡Esperamos
					tus fotos!
				</div>
				<div className='Galeria'>
					{GaleriaEmpresa.map((imagen) => (
						<div className='foto-galeria'>
							<img src={imagen.url} />
							<div className='fondo-borrar-foto '>
								<div
									className='boton-borrar-foto'
									onClick={() => {
										setIdBorrarFoto(imagen.id);
										setModalBorrarFoto(true);
									}}
								>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='20'
										height='20'
										fill='currentColor'
										class='bi bi-trash-fill'
										viewBox='0 0 16 16'
									>
										<path d='M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z' />
									</svg>
								</div>
							</div>
						</div>
					))}
					{GaleriaEmpresa.length < 8 && (
						<div className='foto-galeria add-foto'>
							<div
								className='centrador justify-content-center'
								onClick={() => setModalEnviarFoto(true)}
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='50'
									height='50'
									fill='currentColor'
									class='bi bi-plus-square-fill'
									viewBox='0 0 16 16'
								>
									<path d='M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z' />
								</svg>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};
